module.exports = __webpack_public_path__ + "static/media/01.f0dc98a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/housing/01.jpg
// module id = 139
// module chunks = 0